import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { SlideCheckbox } from '../../ui-kit/SlideCheckbox/SlideCheckbox.js';
import { isAcquiringTrade } from './AcquiringField.js';
export const PosTerminalField = JSX(({ field }) => isAcquiringTrade(field('acquiringType')?.value?.key) ? (_jsx(SlideCheckbox, { type: "radio", text: "\u0425\u043E\u0447\u0443 POS-\u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B", ...field('posTerminal') })) : null);
//# sourceMappingURL=PosTerminalField.js.map